export default "__VITE_ASSET__e8b2787f__"